package horcrux.common.api.dtos

import arrow.core.Either
import arrow.core.raise.either
import horcrux.common.HorcruxEither
import horcrux.common.api.dtos.types.UserFeedback
import horcrux.common.utils.Validatable
import kotlinx.serialization.Serializable

class Feedback {
}

@Serializable
data class PostFeedbackRequest(val userFeedback: UserFeedback) : HorcruxRequest, Validatable<PostFeedbackRequest> {
    override fun validate(): Either<Throwable, PostFeedbackRequest> = either {
        userFeedback.validate().bind()
        this@PostFeedbackRequest
    }
}

@Serializable
class PostFeedbackResponse : HorcruxResponse
